<template>
  <span>
    <v-container
      fluid>
      <v-row>
        <v-col>
          <iframe src="" frameborder="0" height=50 width=70></iframe>
        </v-col>
        <v-col>
          <v-video-chat
            :room="roomId"
            :partnerId="partnerId"/>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      fluid>
      <v-row
        class="sources">
        <v-col>
          <v-js-editor></v-js-editor>
        </v-col>
        <v-col>
          <v-html-editor></v-html-editor>
        </v-col>
        <v-col>
          <v-css-editor></v-css-editor>
        </v-col>
      </v-row>

    </v-container>
  </span>
</template>


<script>
import { app } from '@/core/firebase'
import VJsEditor from '@/components/organisms/editor/VJsEditor'
import VHtmlEditor from '@/components/organisms/editor/VHtmlEditor'
import VCssEditor from '@/components/organisms/editor/VCssEditor'
import VVideoChat from '@/components/organisms/editor/VVideoChat'
export default {
  components: {
    VVideoChat,
    VJsEditor,
    VHtmlEditor,
    VCssEditor
  },
  props: {
    partnerId: {
      type: String,
      required: true
    }
  },
  computed: {
    roomId () {
      return (this.$store.getters.isParent) ? this.$route.params.id + this.partnerId : (this.$store.getters.isTeacher) ? this.partnerId + this.$route.params.id : 'defaultRoom'
    }
  }
}
</script>

<style scoped>
.sources {
  height: 50%;
}
</style>
